
import axios from 'axios'
import { authHeader } from '@/services/auth'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

/**
 * @param filters
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function getNegociateurs (filters) {
  let url = '/negociateurs'
  if (filters.reseau) {
    url += '?reseau=' + filters.reseau
  } else {
    return []
  }
  if (filters.negociateur) {
    url += '&negociateur_code=' + filters.negociateur
  }
  return HTTP_HYPER_ESPACE_BACKEND
    .get(url)
    .then(async response => {
      return response.data
    })
    .catch(error => {
      return error
    })
}
